import stepMixin from "../../utils/mixins/stepMixin.js";
import {SET_SNACKBAR} from '../../store/snackbar/mutation-types';

export default {
  mixins: [stepMixin],
  methods: {
      handleCloseClick(){
          this.SET_SNACKBAR({
              ...this.snackbar,
              value: false
          })
      }
  }
};
